<template>
    <div class="templete no_print">
            <div class="path_title clearfix">
                <span class="path_title_name">欠款审批设置</span>
            </div>
            <div class="path_switch">
                <span>欠款审批{{radio==true?'开启':'关闭'}}：</span>
                <el-switch
                    v-model="radio"
                    @change="timeChange"
                    active-color="#b21111"
                    inactive-color="#777">
                </el-switch>
                <!-- <el-radio-group v-model="radio" @change="timeChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group> -->
            </div>
            <div class="path_tips">
                <div class="tip_top">
                    <i class="iconfont icon-jindianzi returnImg"></i>
                    <span class="tip">提示:</span>
                </div>
                <div>
                    1.开启时:销售单在保存并提交审核的时候，系统自动判断当<span class="fontbold">预计收汇</span>日期大于<span class="fontbold">销售日期</span>时，系统自动弹出OA申请单。
                </div>
                <div>
                    优点: 4步并2步，审核方便，欠款单严控~!
                </div>
                <div class="tipbot">
                    2关闭时:不会触发销售单欠款审批逻辑但业务也可以在OA系统内新建申请单。
                </div>
            </div>
         </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:-150px;z-index:1;width:200px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    // .starList{margin-bottom:10px;}s
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
    .path_tips{text-align: left;margin-bottom: 20px;width: 300px;background-color: #f2f2f2;padding: 10px;}
    .tip_top{color: #FCB917;}
    .tipbot{padding-top: 10px;}
    .fontbold{font-weight: bold;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                radio : "",
                orderTime:"",
                calValue:""
            }
        },
        created(){
            this.postFunc("/erp/system.get.config",{key:"SALES_ORDER_ARREARS",},res=>{
                this.radio = res.data.data.status;
                if(this.radio==1){
                    this.radio=true
                }else if(this.radio==0){
                    this.radio=false
                }
                this.orderTime = res.data.data.value;
                this.calValueInput()
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        methods:{
            calValueInput(){
                this.calValue = parseFloat(100 * Number(this.orderTime)).toFixed(4);
            },
            timeChange(){
                if(this.radio==true){
                    this.radio=1
                }else if(this.radio==false){
                    this.radio=0
                }
                this.postFunc("/erp/system.set.config",{key:"SALES_ORDER_ARREARS",status:this.radio,value:"1"},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
        },
        watch:{
            'radio':function(){
                if(this.radio==1){
                    this.radio=true
                }else if(this.radio==0){
                    this.radio=false
                }
            }
        }
    }
</script>
